import {getComboProductPromotion} from '@/services/ProductComboService/productComboService'
import {useQuery} from '@tanstack/react-query'

/**
 * Gets the promotion details associated with a product combo.
 * @param {string} comboId - Product combo ID to fetch promotion details for.
 */
export const useGetComboPromotion = comboId => {
    const { data } = useQuery({
        queryKey: ['COMBO_PRODUCT_PROMOTION', comboId],
        queryFn: () => getComboProductPromotion(comboId),
    })

    return data?.data || []
}